/* eslint-disable sonarjs/no-duplicate-string */
import {
  admin,
  campaign,
  catalogue,
  category,
  coinEarned,
  coinExchange,
  dashboard,
  fraudSetting,
  hub,
  inboundPoHub,
  inboundPoWarehouse,
  inboundSo,
  location,
  loyaltyActivity,
  loyaltyVoucher,
  // mpPlanning,
  // orderDetail,
  // order,
  // orderPackerPicking,
  // orderPicker,
  koliIDGenerator,
  brandMaster,
  promotion,
  purchaseOrderLite,
  rack,
  referralSetting,
  refund,
  // reorderList,
  serviceLevel,
  setPosition,
  // setting,
  ticker,
  uom,
  schedule,
  masterPayroll,
  bom,
  kitting,
  supplyOrderApproval,
  uniqueVoucherList,
  uniqueVoucherCampaignList,
  loadingDock,
  // timeSlot,
  stockOpnameList,
  bulkUploadV2,
  stockOpnameAdjustment,
  coinHistory,
  // pwp,
  // inboundSchedule,
  koliLost,
  referralMissionList,
  flagManagement,
  // vendorBrandGrouping,
  // fraudWatchTowerQueryRule,
  fraudWatchTowerParameters,
  // routeAndSchedule,
  productAssortment,
  locationPreview,
  createOrder,
  campaignLoyalty,
  dynamicLandingList,
  hcu,
  poolingMap,
  inboundSoWarehouse,
  inboundSoHub,
  // driverMonitoring,
  ticketingCreate,
  ticketingMyTickets,
  ticketingAllTickets,
  // approvalEngine
  approvalEngine,
} from 'config/routes'
import { allowAccess } from 'middleware/privateRoute'
import { warehousePageLocationType, hubPageLocationType } from 'constant/locationType'
import {
  DynamicChannelRouter,
  HomepageSlottingRouter,
  PinProductRouter,
  InfiniteScrollRouter,
  OnboardingMediaRouter,
} from 'features/CategoryAndPosisi/router'
import {
  CampaignSegmentListRouter,
  CampaignAndDiscountRouterDetail,
  CampaignUmbrellaListRouter,
} from 'features/CampaignAndDiscount/router'
import { MultiCategoryRouterDetail } from 'features/MultiCategory/router'
import { TicketScannerRouter } from 'features/AstroEvent/router/'
import {
  BuyerRouter,
  AuthenticationControllRouter,
  AdminAccessRouter,
  adminAccessPagePath,
  CustomerOTPRouter,
  IntoolsAccessRouter,
  intoolsAccessPagePath,
} from 'features/Account/router/'
import {
  ChatChannelRouter,
  BannedKeywordRouter,
} from 'features/Account/router/chatModerationRouter'
import {
  // allowedRolesReorderListSc,
  ReorderListSourcingRouter,
  ReorderListSCRouter,
} from 'features/Enterprise/ReorderList/router'
import { LoyaltyRouterDetail } from 'features/Loyalty/router'
import { SupplyOrderRouterDetail } from 'features/SupplyOrder/router'
import {
  FraudRouterDetail,
  UserFraudStatusRouter,
  WatchtowerAreaDetectionRouter,
  WatchTowerAutoCancelRuleListRouter,
  WatchTowerRuleRouter,
  BlacklistAndWhitelistRouter,
} from 'features/Fraud/router'
import { ProductRouterDetail } from 'features/Product/router'
import {
  ApprovalInjectionRouter,
  PaymentGatewayAdminRouter,
  PaymentDashboardListRouter,
  DisbursementRouter,
} from 'features/Payment/router'
import { OrderRouterDetail, OnGoingRoutes } from 'features/Order/router'
import { PromotionRouterDetail, MilestoneListRouter } from 'features/Promotion/router'
import {
  BannerThematicRouter,
  BannerRouter,
  PromoReferralWidgetRouter,
} from 'features/BannerAndTicker/router'
import { VariantModuleRouter } from 'features/Product/router/router'
import { MPBudgetRouter } from 'features/Enterprise/HRIS/router'
import {
  InternalSKPRouter,
  CampaignRouter,
  FinanceRouter,
  SKPRouterDetail,
} from 'features/Enterprise/SKP/router'
import {
  VendorListRouter,
  vendorPath,
  VendorInvoiceListRouter,
  VendorBrandGroupRouter,
} from 'features/Enterprise/Vendor/router'
import * as SOAutomationRouter from 'features/Enterprise/SOAutomation/router'
import { AssetManagementRouterDetail } from 'features/AssetManagement/router'
import { ABAdminRouterDetail } from 'features/ABAdmin/router'
import {
  ScheduleRouter,
  AttendanceRouter,
  MasterApprovalRouter,
  MasterShiftRouter,
  OJTSlottingRouter,
} from 'features/Enterprise/Schedules/router'
import {
  HubWeatherRouter,
  BlacklistAreaRouter,
  GreylistAreaRouter,
  GreylistAreaAddEditRouter,
  GreylistAreaDetailRouter,
  IsochroneVersioningRouter,
  AdjacentHubRouter,
} from 'features/Location/router'
import { MPStaffRouter, MPHiringFunnelRouter } from 'features/Enterprise/Account/router'
import {
  generatePathSegmentListPage,
  SegmentationPageRouter,
  WhitelistSegmentPageRouter,
  SegmentationCreateEditPageRouter,
} from 'features/Segmentation/router'
import { AdsManagementRouterDetail } from 'features/AdsManagement/router'

import { categoryRBAC } from 'pages/Category/rbac'
import { catalogRBAC } from 'pages/Catalogue/rbac'
import { locationRBAC } from 'pages/Location/rbac'
import { refundRBAC } from 'features/Payment/pages/Refund/rbac'
import { locationPreviewRBAC } from 'pages/LocationPreview/rbac'
import { featureFlagRBAC } from 'pages/FlagManagement/rbac'
import { serviceLevelRBAC } from 'pages/ServiceLevel/rbac'
import { PoolingMapRolesRBAC } from 'features/Order/pages/PoolingMap/rbac'
import { CreateOrderRolesRBAC } from 'features/Order/pages/CreateOrder/rbac'
import { RackRouterDetail } from 'features/Rack/router'
import { HCURolesRBAC } from 'features/HCU/rbac'
import { AdminRBAC } from 'pages/Admin/rbac'
import { HubWeatherRBAC } from 'features/Location/pages/HubWeather/rbac'
import {
  pricingEngineDefaultPath,
  PricingEngineProductRouter,
} from 'features/PricingEngine/router/router'
import { bomRBAC } from 'pages/BoM/rbac'
import { DriverMonitoringRolesRBAC } from 'features/Order/pages/DriverMonitoring/rbac'
import { GenerateKoliPageRBAC } from 'pages/KoliIDGenerator/rbac'
import { KoliLostPageRBAC } from 'pages/KoliLost/rbac'
import { CustomerRBAC } from 'features/Account/pages/Buyer/rbac'
import { DynamicChannelRBAC } from 'features/CategoryAndPosisi/pages/DynamicChannel/rbac'
import { PurchaseOrderRouterDetail } from 'features/PurchaseOrder/router'
import { AdditionalSLARolesRBAC } from 'features/Order/pages/AdditionalSLA/rbac'
import { promotionRBAC } from 'pages/Promotion/rbac'
import { CampaignListRolesRBAC } from 'features/CampaignAndDiscount/pages/CampaignList/rbac'
import { CampaignSegmentListRolesRBAC } from 'features/CampaignAndDiscount/pages/CampaignSegmentList/rbac'
import {
  MasterPayrollOldRouter,
  MasterPayrollRouter,
  MasterPayslipRouter,
  MasterRateRouter,
} from 'features/Enterprise/Payroll/router'
import { kittingRBAC } from 'pages/Kitting/rbac'
import { supplyOrderApprovalPageRBAC } from 'pages/SupplyOrderApproval/rbac'
import { XdockRBAC } from 'features/SupplyOrder/pages/Xdock/rbac'
import { XdockV2RBAC } from 'features/SupplyOrder/pages/XdockV2/rbac'
import { limitSkuPageRBAC } from 'features/SupplyOrder/pages/LimitSKU/rbac'
import { PutawayHubPageRBAC } from 'features/SupplyOrder/pages/PutawayHub/rbac'
import { ReplenishmentTaskPageRBAC } from 'features/SupplyOrder/pages/ReplenishmentTask/rbac'
import { referralMissionListRBAC } from 'features/Promotion/pages/ReferralMission/ReferralMissionList/rbac'
import { ReplenishmentScheduleRBAC } from 'features/SupplyOrder/pages/ReplenishmentSchedule/rbac'
import { ReplenishmentConfigPageRBAC } from 'features/SupplyOrder/pages/ReplenishmentConfig/rbac'
import {
  InboundScheduleRouter,
  MasterTimeSlotRouter,
  LoadingDockRouter,
} from 'features/Enterprise/CapacityHandler/router'
import { UserFraudStatusRBAC } from 'features/Fraud/pages/UserFraudStatus/rbac'
import { WatchtowerAreaDetectionRBAC } from 'features/Fraud/pages/WatchtowerAreaDetection/rbac'
import { WatchtowerParameterRBAC } from 'pages/Fraud/WatchTowerParameters/rbac'
import {
  WatchtowerRuleListRBAC,
  WatchtowerAutoCancelRuleListRBAC,
} from 'features/Fraud/pages/WatchTowerRule/rbac'
import { flashSaleRBAC } from 'features/Promotion/pages/FlashSale/rbac'
import { milestoneListRBAC } from 'features/Promotion/pages/MilestoneList/rbac'
import { uniqueVoucherVoucherListRolesRBAC } from 'features/Promotion/pages/UniqueVoucher/VoucherList/rbac'
import { uniqueVoucherCampaignListRolesRBAC } from 'features/Promotion/pages/UniqueVoucher/CampaignList/rbac'
import { referralSettignRBAC } from 'pages/ReferralSetting/rbac'
import { AuthenticationControllRBAC } from 'features/Account/pages/AuthenticationControll/rbac'
import { SoParametersPageRBAC } from 'features/Enterprise/SOAutomation/pages/SOParameters/rbac'
import { SoSchedulesPageRBAC } from 'features/Enterprise/SOAutomation/pages/SOSchedules/rbac'
import { SoReportPageRBAC } from 'features/Enterprise/SOAutomation/pages/SOReports/rbac'
import { ModifierPageRBAC } from 'features/Product/pages/Modifier/rbac'
import { ModifierConnectionPageRBAC } from 'features/Product/pages/ModifierConnection/rbac'
import { uomRBAC } from 'pages/Uom/rbac'
import { brandRBAC } from 'pages/BrandMaster/rbac'
import { productAssortmentRBAC } from 'pages/ProductAssortment/rbac'
import { GenerateAssetRBAC } from 'features/SupplyOrder/pages/GenerateAssetId/rbac'
import { DynamicLandingPageRBAC } from 'pages/DynamicLandingList/rbac'
import {
  CreatePoRBAC,
  PoInboundHubRBAC,
  PoInboundWarehouseRBAC,
  PoInboundMegahubRBAC,
  PoApprovalRBAC,
} from 'pages/PurchaseOrderLite/rbac'

import { ReactNode } from 'react'
import {
  Discount,
  Category,
  Capacity,
  DashboardTile,
  Refund,
  Microsite,
  Package,
  Promo,
  Calendar,
  Payroll,
  Banner,
  Location,
  Group,
  PurchaseOrder,
  Inbound,
  Outbound,
  KittingDeKitting,
  Pesanan,
  Promotional,
  Fraud,
  Loyalty,
  Setting,
  Rak,
  AddNote,
  Scan,
  Warehouse,
  Retur,
  Payment,
  DeliveryCar,
  FilledCart,
  EmptyCart,
  UploadDoc,
  VendorManagement,
  Doc,
  Area,
  Message,
} from '@astronautsid/wpe-icons'
import { FraudBlacklistAndWhitelistRBAC } from 'features/Fraud/pages/BlacklistAndWhitelist/rbac'
import { FraudDetectionRBAC } from 'features/Fraud/pages/FraudDetection/rbac'
import { FraudSettingRBAC } from 'pages/FraudSetting/rbac'
import { DynamicPricingTableRouter } from 'features/DynamicPricing/router'
import { ThreePLQuotaRouterDetail } from 'features/3PLQuota/router/router'
import { SetPositionRBAC } from 'pages/SetPosition/rbac'
import { TickerRBAC } from 'pages/Ticker/rbac'
import { OnGoingV2Routes } from 'features/Order/router/router'
import { OngoingOrdersRBAC } from 'features/Order/pages/OngoingOrdersV2/rbac'
import { PromotionReferralWidgetRBAC } from 'features/BannerAndTicker/pages/PromoWidget/rbac'
import { MasterAreaPickingListRouter } from 'features/MasterAreaPicking/router/router'
import {
  MasterTimeSlotRBAC,
  MasterLoadingDockRBAC,
  InboundScheduleRBAC,
} from 'features/Enterprise/CapacityHandler/router/rbac'
import { RouteAndScheduleListRouter } from 'features/Midmile/router/router'
import { InboundSupplyOrderHubRBAC, InboundSupplyOrderWarehouseRBAC } from 'pages/InboundHubSo/rbac'
import { stockOpnameRBAC } from 'pages/StockOpname/StockOpnameList/rbac'
import { stockOpnameAdjustmentRBAC } from 'pages/StockOpname/StockOpnameAdjustment/rbac'
import { AdditionalSLALogRolesRBAC } from 'features/Order/pages/ASLALog/rbac'
import { DemandPlanningRouter, ConfigBankRouter } from 'features/SCMS/router'
import {
  CreateTicketRoute,
  MyTicketsRoute,
  AllTicketsRoute,
} from 'features/Ticketing/router/router'

/* edit menu disini */
// @active_paths diisi dengan path yang mengacu ke route tsb
// misal: pathnya '/dashboard/admin', maka activePathsnya diisi ['/dashboard/admin', '/dashboard/admin/:id'] dst

export type SidebarConfigType = {
  name: string
  id: string
  link?: string
  icon?: ReactNode
  location_type?: string[]
  allow?: string[]
  allowAll?: boolean
  pageID?: string
  multipleLinkWithPageID?: {
    link: string
    pageID: string
  }[]
  activePaths?: string[]
  subMenu?: Omit<SidebarConfigType[number], 'subMenu'>[]
}[]

const config: SidebarConfigType = [
  {
    name: 'Dashboard',
    id: 'dashboard',
    link: dashboard,
    icon: <DashboardTile type="solid" />,
    allow: allowAccess.dashboard,
  },
  {
    name: 'Bulk Upload',
    id: 'bulkUpload',
    link: bulkUploadV2,
    icon: <UploadDoc type="solid" />,
    allow: allowAccess.bulkUploadV2,
    allowAll: true,
  },
  {
    name: 'SCMS',
    id: 'scms',
    link: '',
    icon: <Warehouse type="solid" />,
    subMenu: [
      {
        name: 'Demand Planning',
        id: 'demand_planning',
        link: DemandPlanningRouter.path,
        pageID: DemandPlanningRouter.rbacPageID,
      },
      {
        name: 'Config Bank',
        id: 'config_bank',
        link: ConfigBankRouter.path,
        pageID: ConfigBankRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Kategori & Posisi',
    id: 'category_and_position',
    link: category,
    icon: <Category type="solid" />,
    allow: allowAccess.category_and_position,
    subMenu: [
      {
        name: 'Kategori',
        id: 'category',
        link: category,
        pageID: categoryRBAC.pageID,
      },
      {
        name: 'UOM',
        id: 'UOM',
        link: `${uom}`,
        allow: [],
        pageID: uomRBAC.pageID,
      },
      {
        name: 'Set Posisi',
        id: 'set_position',
        link: setPosition,
        pageID: SetPositionRBAC.pageID,
      },
      {
        name: 'Katalog',
        id: 'catalogue',
        link: catalogue,
        pageID: catalogRBAC.pageID,
      },
      {
        name: 'Pin Produk',
        id: 'pin_product',
        link: PinProductRouter.path,
        pageID: PinProductRouter.rbacPageID,
        allow: PinProductRouter.allowedRoles,
      },
      {
        name: 'Dynamic Channel',
        id: 'dynamic_channel',
        link: DynamicChannelRouter.path,
        allow: DynamicChannelRouter.allowedRoles,
        pageID: DynamicChannelRBAC.pageID,
      },
      {
        name: 'Homepage Slotting',
        id: 'homepage_slotting',
        link: HomepageSlottingRouter.path,
        pageID: HomepageSlottingRouter.rbacPageID,
      },
      {
        name: 'Infinite Scroll Tab',
        id: 'infinite_scroll',
        link: InfiniteScrollRouter.path,
        pageID: InfiniteScrollRouter.rbacPageID,
      },
      {
        name: 'Onboarding Media',
        id: 'onboarding_media',
        link: OnboardingMediaRouter.path,
        allow: OnboardingMediaRouter.allowedRoles,
        pageID: OnboardingMediaRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Pricing Engine',
    id: 'pricingEngine',
    link: pricingEngineDefaultPath,
    icon: <Refund type="solid" />,
    subMenu: [
      {
        name: 'Pricing Engine',
        id: 'pricingEngine',
        link: pricingEngineDefaultPath,
        multipleLinkWithPageID: [
          {
            link: PricingEngineProductRouter.path.replace(':page', 'products'),
            pageID:
              PricingEngineProductRouter.multiplePageID?.pageIDmatchWithKeySegments.products || '',
          },
          {
            link: PricingEngineProductRouter.path.replace(':page', 'requests'),
            pageID:
              PricingEngineProductRouter.multiplePageID?.pageIDmatchWithKeySegments.requests || '',
          },
          {
            link: PricingEngineProductRouter.path.replace(':page', 'history'),
            pageID:
              PricingEngineProductRouter.multiplePageID?.pageIDmatchWithKeySegments.history || '',
          },
        ],
      },
      {
        name: 'Dynamic Pricing',
        id: 'dynamicPricing',
        link: DynamicPricingTableRouter.path,
        pageID: DynamicPricingTableRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Dynamic LP',
    id: 'dynamic-landing',
    link: dynamicLandingList,
    icon: <Microsite type="solid" />,
    pageID: DynamicLandingPageRBAC.pageID,
  },
  {
    name: 'Vendor',
    id: 'vendor',
    link: vendorPath,
    icon: <VendorManagement type="solid" />,
    subMenu: [
      {
        name: 'Vendor List',
        id: 'vendorList',
        link: VendorListRouter.path,
        pageID: VendorListRouter.rbacPageID,
      },
      {
        name: 'Vendor Invoice',
        id: 'vendorList',
        link: VendorInvoiceListRouter.path,
        pageID: VendorInvoiceListRouter.rbacPageID,
      },
      {
        name: 'Vendor Brand Group',
        id: 'vendorBrandGroup',
        link: VendorBrandGroupRouter.path,
        pageID: VendorBrandGroupRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Produk & Stok',
    id: 'product_and_stock',
    link: ProductRouterDetail.ProductRouter.path,
    icon: <Package type="solid" />,
    subMenu: [
      {
        name: 'Product',
        id: 'product',
        link: ProductRouterDetail.ProductRouter.path,
        pageID: ProductRouterDetail.ProductRouter.rbacPageID,
      },
      {
        name: 'SKU Registration',
        id: 'sku_registration',
        link: ProductRouterDetail.SkuRegistrationList.path,
        allow: ProductRouterDetail.SkuRegistrationList.allowedRoles,
        pageID: ProductRouterDetail.SkuRegistrationList.rbacPageID,
      },
      {
        name: 'Brand Master',
        id: 'brand-master',
        link: brandMaster,
        pageID: brandRBAC.pageID,
      },
      {
        name: 'Hub',
        id: 'hub',
        link: hub,
        location_type: ['HUB'],
        pageID: ProductRouterDetail.HubRouter.rbacPageID,
      },
      {
        name: 'Warehouse',
        id: 'warehouse',
        link: ProductRouterDetail.WarehouseRouter.path,
        location_type: ['WAREHOUSE'],
        pageID: ProductRouterDetail.WarehouseRouter.rbacPageID,
      },
      {
        name: 'Product Assortment',
        id: 'productAssortment',
        link: productAssortment,
        pageID: productAssortmentRBAC.pageID,
        allow: [],
      },
      {
        name: 'Product Label',
        id: 'productLabel',
        link: ProductRouterDetail.ProductLabel.path,
        pageID: ProductRouterDetail.ProductLabel.rbacPageID,
      },
      {
        name: 'Conversion Rule',
        id: 'conversionRule',
        link: ProductRouterDetail.ConversionRuleRouter.path,
        pageID: ProductRouterDetail.ConversionRuleRouter.rbacPageID,
      },
      {
        name: 'Conversion Task',
        id: 'conversionTask',
        link: ProductRouterDetail.ConversionTaskRouter.path,
        pageID: ProductRouterDetail.ConversionTaskRouter.rbacPageID,
      },
      {
        name: 'Price Tag',
        id: 'priceTag',
        link: ProductRouterDetail.PriceTagRouter.path,

        allow: ProductRouterDetail.PriceTagRouter.allowedRoles,
      },
    ],
  },
  {
    name: 'Asset Management',
    id: 'asset-management',
    link: ``,
    icon: <Warehouse type="solid" />,
    subMenu: [
      {
        name: 'Product Asset',
        id: 'product-asset',
        link: AssetManagementRouterDetail.productAssetList.path,
        pageID: AssetManagementRouterDetail.productAssetList.rbacPageID,
      },
      {
        name: 'Asset Master',
        id: 'asset-master',
        link: AssetManagementRouterDetail.assetMaster.path,
        pageID: AssetManagementRouterDetail.assetMaster.rbacPageID,
      },
      {
        name: 'Purchase Order',
        id: 'purchase-order',
        link: AssetManagementRouterDetail.purchaseOrderAsset.path,
        pageID: AssetManagementRouterDetail.purchaseOrderAsset.rbacPageID,
      },
      {
        name: 'Supply Order',
        id: 'supply-order',
        link: AssetManagementRouterDetail.supplyOrderListRoute.path,
        pageID: AssetManagementRouterDetail.supplyOrderListRoute.rbacPageID,
      },
      {
        name: 'Handheld Monitoring',
        id: 'handheld-monitoring',
        link: AssetManagementRouterDetail.handheldMonitoringRoute.path,
        pageID: AssetManagementRouterDetail.handheldMonitoringRoute.rbacPageID,
      },
    ],
  },
  {
    name: 'Approval Engine',
    id: 'approval_engine',
    link: approvalEngine,
    icon: <Doc type="solid" />,
    allowAll: true,
  },
  {
    name: 'Multicategory',
    id: 'multicategory',
    link: MultiCategoryRouterDetail.MultiCategoryHomepageListRouter.path,
    icon: <Category type="solid" />,
    allowAll: true,
  },
  {
    name: 'Varian',
    id: 'variant',
    link: VariantModuleRouter.path,
    icon: <FilledCart type="solid" />,
    allow: VariantModuleRouter.allowedRoles,
    subMenu: [
      {
        name: 'Master Varian',
        id: 'master-variant',
        link: ProductRouterDetail.MasterVariantRouter.path,
        pageID: ProductRouterDetail.MasterVariantRouter.rbacPageID,
      },
      {
        name: 'Produk Varian',
        id: 'product-variant',
        link: ProductRouterDetail.ProductVariantRouter.path,
        pageID: ProductRouterDetail.ProductVariantRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Modifier',
    id: 'modifier',
    link: ProductRouterDetail.ModifierRouter.path,
    icon: <EmptyCart type="solid" />,
    subMenu: [
      {
        name: 'Semua Modifier',
        id: 'modifier-all',
        link: ProductRouterDetail.ModifierRouter.path,
        pageID: ModifierPageRBAC.pageID,
      },
      {
        name: 'Hubungan Modifier',
        id: 'modifier-connection',
        link: ProductRouterDetail.ModifierConnectionRouter.path,
        pageID: ModifierConnectionPageRBAC.pageID,
      },
    ],
  },
  {
    name: 'Stok Opname',
    id: 'stock-opname',
    link: stockOpnameList,
    icon: <Retur type="solid" />,
    subMenu: [
      {
        name: 'Stock Opname',
        id: 'stock-opname-list',
        link: stockOpnameList,
        pageID: stockOpnameRBAC.pageID,
      },
      {
        name: 'Adjustment',
        id: 'stock-opname-adjustment',
        link: stockOpnameAdjustment,
        pageID: stockOpnameAdjustmentRBAC.pageID,
      },
    ],
  },
  {
    name: 'Payment',
    id: 'refund_and_disburse',
    link: refund,
    icon: <Payment type="solid" />,
    allow: allowAccess.refundAndDisburse,
    subMenu: [
      {
        name: 'Refund',
        id: 'refund',
        link: refund,
        pageID: refundRBAC.pageID,
      },
      {
        name: 'Disbursement',
        id: 'disbursement',
        link: DisbursementRouter.path,
        pageID: DisbursementRouter.rbacPageID,
        allow: DisbursementRouter.allowedRoles,
      },
      {
        name: 'Approval Inject',
        id: 'approvalInjection',
        link: ApprovalInjectionRouter.path,
        pageID: ApprovalInjectionRouter.rbacPageID,
      },
      {
        name: 'Payment Gateway',
        id: 'paymentGateway',
        link: PaymentGatewayAdminRouter.path,
        pageID: PaymentGatewayAdminRouter.rbacPageID,
      },
      {
        name: 'Semua Pembayaran',
        id: 'paymentDashboard',
        link: PaymentDashboardListRouter.path,
        pageID: PaymentDashboardListRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Midmile',
    id: 'midmile',
    icon: <DeliveryCar type="solid" />,
    subMenu: [
      {
        name: 'Rute & Jadwal',
        id: 'route_schedule',
        link: RouteAndScheduleListRouter.path,
        pageID: RouteAndScheduleListRouter.rbacPageID,
      },
    ],
  },

  {
    name: 'Campaign & Diskon',
    id: 'campaign',
    link: campaign,
    icon: <Promo type="solid" />,
    allow: [
      ...CampaignAndDiscountRouterDetail.CampaignListRouter.allowedRoles,
      ...CampaignAndDiscountRouterDetail.CampaignSegmentListRouter.allowedRoles,
    ],
    subMenu: [
      {
        name: 'Campaign Umbrella',
        id: 'campaign-umbrella',
        link: CampaignUmbrellaListRouter.path,
        pageID: CampaignUmbrellaListRouter.rbacPageID,
      },
      {
        name: 'Campaign',
        id: 'campaign_sub',
        link: campaign,
        pageID: CampaignListRolesRBAC.pageID,
        allow: CampaignAndDiscountRouterDetail.CampaignListRouter.allowedRoles,
      },
      {
        name: 'Segmen User',
        id: 'user-segment',
        link: CampaignSegmentListRouter.path,
        pageID: CampaignSegmentListRolesRBAC.pageID,
        allow: CampaignAndDiscountRouterDetail.CampaignSegmentListRouter.allowedRoles,
      },
    ],
  },

  {
    name: 'Segmentation',
    id: 'segmentation',
    icon: <Area type="solid" />,
    subMenu: [
      {
        name: 'Segment List',
        id: 'segment-list',
        link: generatePathSegmentListPage('segment'),
        pageID: SegmentationPageRouter.rbacPageID,
        activePaths: [SegmentationPageRouter.path, SegmentationCreateEditPageRouter.path],
      },
      {
        name: 'Whitelist Segment',
        id: 'segment-whitelist',
        link: WhitelistSegmentPageRouter.path,
        pageID: WhitelistSegmentPageRouter.rbacPageID,
        activePaths: [WhitelistSegmentPageRouter.path],
      },
    ],
  },
  {
    name: 'Ads Management',
    id: 'ads-management',
    link: ``,
    icon: <VendorManagement type="solid" />,
    subMenu: [
      {
        name: 'Principal List',
        id: 'principal-list',
        link: AdsManagementRouterDetail.adsPrincipalListRoute.path,
        pageID: AdsManagementRouterDetail.adsPrincipalListRoute.rbacPageID,
      },
      {
        name: 'Approval Ads',
        id: 'ads-approval',
        link: AdsManagementRouterDetail.adsApprovalRoute.path,
        pageID: AdsManagementRouterDetail.adsApprovalRoute.rbacPageID,
      },
      {
        name: 'Faktur Pajak Ads',
        id: 'ads-efaktur',
        link: AdsManagementRouterDetail.adsEfakturRoute.path,
        pageID: AdsManagementRouterDetail.adsEfakturRoute.rbacPageID,
      },
      {
        name: 'Refund PPh23 Ads',
        id: 'ads-pph23-refund',
        link: AdsManagementRouterDetail.adsPph23RefundRoute.path,
        pageID: AdsManagementRouterDetail.adsPph23RefundRoute.rbacPageID,
      },
    ],
  },
  {
    name: 'Atur Jadwal',
    id: 'staff-driver',
    link: schedule,
    icon: <Calendar type="solid" />,
    subMenu: [
      {
        name: 'Jadwal Kerja',
        id: 'schedule-staff',
        link: ScheduleRouter.path,
        pageID: ScheduleRouter.rbacPageID,
      },
      {
        name: 'Master Approval',
        id: 'schedule-master-approval',
        link: MasterApprovalRouter.path,
        pageID: MasterApprovalRouter.rbacPageID,
      },
      {
        name: 'Riwayat Absensi',
        id: 'schedule-attendance',
        link: AttendanceRouter.path,
        pageID: AttendanceRouter.rbacPageID,
      },
      {
        name: 'Master Shift',
        id: 'schedule-master-shift',
        link: MasterShiftRouter.path,
        pageID: MasterShiftRouter.rbacPageID,
      },
      {
        name: 'OJT Slotting',
        id: 'ojt-slotting',
        link: OJTSlottingRouter.path,
        pageID: OJTSlottingRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Banner & Ticker',
    id: 'banner',
    icon: <Banner type="solid" />,
    link: BannerRouter.path,
    allow: allowAccess.banner_and_ticker,
    subMenu: [
      {
        name: 'Banner Regular',
        id: 'banner sub',
        link: BannerRouter.path,
        pageID: BannerRouter.rbacPageID,
      },
      {
        name: 'Banner Thematic',
        id: 'bannerThematic',
        link: BannerThematicRouter.path,
        pageID: BannerThematicRouter.rbacPageID,
      },
      {
        name: 'Ticker',
        id: 'ticker',
        link: ticker,
        pageID: TickerRBAC.pageID,
      },
      {
        name: 'Promo Referral Widget',
        id: 'promo-referral-widget',
        link: PromoReferralWidgetRouter.path,
        pageID: PromotionReferralWidgetRBAC.pageID,
      },
    ],
  },
  {
    name: 'Lokasi',
    id: 'location',
    link: location,
    icon: <Location type="solid" />,
    subMenu: [
      {
        name: 'Lokasi',
        id: 'location',
        link: location,
        pageID: locationRBAC.pageID,
      },
      {
        name: 'Nearby Hub Master',
        id: 'adjacentHub',
        link: AdjacentHubRouter.path,
        pageID: AdjacentHubRouter.rbacPageID,
      },
      {
        name: 'Lokasi Preview',
        id: 'locationPreview',
        link: locationPreview,
        pageID: locationPreviewRBAC.pageID,
      },
      {
        name: 'Isochrone Versioning',
        id: 'isochrone_versioning',
        link: IsochroneVersioningRouter.path,
        pageID: IsochroneVersioningRouter.rbacPageID,
      },

      {
        name: '3PL Quota',
        id: '3plquota',
        link: ThreePLQuotaRouterDetail.ThreePLQuotaRouter.path,
        pageID: ThreePLQuotaRouterDetail.ThreePLQuotaRouter.rbacPageID,
      },
      {
        name: 'Pengaturan Fitur',
        id: 'flagManagement',
        link: flagManagement,
        pageID: featureFlagRBAC.pageID,
      },
      {
        name: 'Service Level',
        id: 'service_level',
        link: serviceLevel,

        pageID: serviceLevelRBAC.pageID,
      },
      {
        name: 'Cuaca Di Hub',
        id: 'cuaca_di_hub',
        link: HubWeatherRouter.path,
        pageID: HubWeatherRBAC.pageID,
      },
      {
        name: 'Blacklist Area',
        id: 'blacklist_area',
        link: BlacklistAreaRouter.path,
        pageID: BlacklistAreaRouter.rbacPageID,
      },
      {
        name: 'Restricted Area',
        id: 'restricted_area',
        link: GreylistAreaRouter.path,
        pageID: GreylistAreaRouter.rbacPageID,
        activePaths: [GreylistAreaAddEditRouter.path, GreylistAreaDetailRouter.path],
      },
    ],
  },
  {
    name: 'Akun',
    id: 'account',
    link: admin,
    icon: <Group type="solid" />,
    subMenu: [
      {
        name: 'Admin Access',
        id: 'admin-access',

        multipleLinkWithPageID: [
          {
            link: adminAccessPagePath('admin-access', 'user'),
            pageID: AdminAccessRouter.multiplePageID?.pageIDmatchWithKeySegments.user || '',
          },
          {
            link: adminAccessPagePath('admin-access', 'page'),
            pageID: AdminAccessRouter.multiplePageID?.pageIDmatchWithKeySegments.page || '',
          },
          {
            link: adminAccessPagePath('admin-access', 'roles'),
            pageID: AdminAccessRouter.multiplePageID?.pageIDmatchWithKeySegments.roles || '',
          },
        ],
      },
      {
        name: 'Vendor Access',
        id: 'vendor-access',
        multipleLinkWithPageID: [
          {
            link: adminAccessPagePath('vendor-access', 'vendorUser'),
            pageID: AdminAccessRouter.multiplePageID?.pageIDmatchWithKeySegments.vendorUser || '',
          },
          {
            link: adminAccessPagePath('vendor-access', 'vendorRoles'),
            pageID: AdminAccessRouter.multiplePageID?.pageIDmatchWithKeySegments.vendorRoles || '',
          },
          {
            link: adminAccessPagePath('vendor-access', 'vendorPage'),
            pageID: AdminAccessRouter.multiplePageID?.pageIDmatchWithKeySegments.vendorPage || '',
          },
        ],
      },
      {
        name: 'Intools Access',
        id: 'intools-access',
        multipleLinkWithPageID: [
          {
            link: intoolsAccessPagePath('intools-access', 'user'),
            pageID: IntoolsAccessRouter.multiplePageID?.pageIDmatchWithKeySegments.user || '',
          },
          {
            link: intoolsAccessPagePath('intools-access', 'roles'),
            pageID: IntoolsAccessRouter.multiplePageID?.pageIDmatchWithKeySegments.roles || '',
          },
          {
            link: intoolsAccessPagePath('intools-access', 'page'),
            pageID: IntoolsAccessRouter.multiplePageID?.pageIDmatchWithKeySegments.page || '',
          },
        ],
      },
      {
        name: 'Admin',
        id: 'admin',
        link: admin,
        pageID: AdminRBAC.pageID,
        allow: allowAccess.admin,
      },
      {
        name: 'MP Staff',
        id: 'mpStaff',
        link: MPStaffRouter.path,
        allow: MPStaffRouter.allowedRoles,
        pageID: MPStaffRouter.rbacPageID,
      },
      {
        name: 'MP Hiring Funnel',
        id: 'mpHiringFunnel',
        link: MPHiringFunnelRouter.path,
        pageID: MPHiringFunnelRouter.rbacPageID,
      },
      {
        name: 'MP Budget',
        id: 'mp_budget',
        link: MPBudgetRouter.path,

        allow: MPBudgetRouter.allowedRoles,
      },
      {
        name: 'Customer',
        id: 'buyer',
        link: BuyerRouter.path,
        pageID: CustomerRBAC.pageID,
        allow: BuyerRouter.allowedRoles,
      },
      {
        name: 'Auth Control',
        id: 'AuthControll',
        pageID: AuthenticationControllRBAC.pageID,
        allow: AuthenticationControllRouter.allowedRoles,
        link: AuthenticationControllRouter.path,
      },
      {
        name: 'OTP Blacklist',
        id: 'otp-blacklist',
        pageID: CustomerOTPRouter.rbacPageID,
        link: CustomerOTPRouter.path,
      },
    ],
  },
  {
    name: 'Payroll',
    id: 'payroll',
    link: masterPayroll,
    icon: <Payroll type="solid" />,
    allow: MasterPayrollRouter.allowedRoles,
    subMenu: [
      {
        name: 'Master Payslip',
        id: 'master-payslip',
        link: MasterPayslipRouter.path,
        pageID: MasterPayslipRouter.rbacPageID,
      },
      {
        name: 'Master Rate',
        id: 'master-rate',
        link: MasterRateRouter.path,
        pageID: MasterRateRouter.rbacPageID,
      },
      {
        name: 'Master Payroll',
        id: 'master-payroll',
        link: MasterPayrollRouter.path,
        pageID: MasterPayrollRouter.rbacPageID,
      },
      {
        name: 'Master Payroll (Old)',
        id: 'master-payroll-old',
        link: MasterPayrollOldRouter.path,
        pageID: MasterPayrollRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Purchase Order',
    id: 'purchase_order',
    link: purchaseOrderLite,
    icon: <PurchaseOrder type="solid" />,
    subMenu: [
      {
        name: 'Create PO',
        id: 'create_purchase_order',
        link: purchaseOrderLite,
        location_type: [
          'HUB',
          'WAREHOUSE',
          'ASTRO OFFLINE',
          'MEGAHUB 2.0',
          'VIRTUAL',
          'OFFICE',
          'VENDING MACHINE',
          'MEGAHUB',
          'DIGITAL GOODS',
        ],
        pageID: CreatePoRBAC.pageID,
      },
      {
        name: 'Create PO (new)',
        id: 'create_purchase_order_new',
        link: PurchaseOrderRouterDetail.PurchaseOrderCreateRouter.path,
        location_type: [
          'HUB',
          'WAREHOUSE',
          'ASTRO OFFLINE',
          'MEGAHUB 2.0',
          'VIRTUAL',
          'OFFICE',
          'VENDING MACHINE',
          'MEGAHUB',
          'DIGITAL GOODS',
        ],
        pageID: PurchaseOrderRouterDetail.PurchaseOrderCreateRouter.rbacPageID,
      },
      {
        name: 'Inbound - Hub',
        id: 'inbound_hub_po',
        link: `${inboundPoHub}?locationType=hub,${encodeURI('astro offline')}&status=`,
        location_type: ['HUB', 'ASTRO OFFLINE'],
        pageID: PoInboundHubRBAC.pageID,
      },
      {
        name: 'Inbound - Hub (new)',
        id: 'inbound_hub_po_new',
        link: PurchaseOrderRouterDetail.PurchaseOrderInboundHubRouter.path,
        location_type: ['HUB', 'ASTRO OFFLINE'],
        pageID: PurchaseOrderRouterDetail.PurchaseOrderInboundHubRouter.rbacPageID,
      },
      {
        name: 'Inbound - WRHS',
        id: 'inbound_warehouse_po',
        link: `${inboundPoWarehouse}?locationType=warehouse&status=`,
        location_type: ['WAREHOUSE'],
        pageID: PoInboundWarehouseRBAC.pageID,
      },
      {
        name: 'Inbound - WRHS (new)',
        id: 'inbound_warehouse_po_new',
        link: PurchaseOrderRouterDetail.PurchaseOrderInboundWarehouseRouter.path,
        location_type: ['WAREHOUSE'],
        pageID: PurchaseOrderRouterDetail.PurchaseOrderInboundWarehouseRouter.rbacPageID,
      },
      {
        name: 'Reorder List SC',
        id: 'reorder_list_sc',
        link: ReorderListSCRouter.path,
        pageID: ReorderListSCRouter.rbacPageID,
      },
      {
        name: 'Reorder List Sourcing',
        id: 'reorder_list_sourcing',
        link: ReorderListSourcingRouter.path,
        pageID: ReorderListSourcingRouter.rbacPageID,
      },
      {
        name: 'Direct Putaway',
        id: 'direct_putaway',
        link: PurchaseOrderRouterDetail.DirectPutawayOldRouter.path,
        pageID: PurchaseOrderRouterDetail.DirectPutawayOldRouter.rbacPageID,
      },
      {
        name: 'Direct Putaway (New)',
        id: 'direct_putaway_new',
        link: PurchaseOrderRouterDetail.DirectPutawayRouter.path,
        pageID: PurchaseOrderRouterDetail.DirectPutawayRouter.rbacPageID,
      },
      {
        name: 'Inbound Task',
        id: 'inbound_task',
        link: PurchaseOrderRouterDetail.InboundTaskRouter.path,
        pageID: PurchaseOrderRouterDetail.InboundTaskRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Kitting De-Kitting',
    id: 'Kitting De-Kitting',
    link: kitting,
    icon: <KittingDeKitting type="solid" />,
    allow: allowAccess.kitting_de_kitting,
    subMenu: [
      {
        name: 'Kitting De-Kitting',
        id: 'Kitting De-Kitting',
        link: kitting,
        pageID: kittingRBAC.pageID,
        allow: allowAccess.kitting_de_kitting,
      },
      {
        name: 'BoM',
        id: 'bom',
        link: bom,
        pageID: bomRBAC.pageID,
        allow: allowAccess.kitting_de_kitting,
      },
    ],
  },
  {
    name: 'Inbound',
    id: 'Inbound',
    link: inboundSo,
    icon: <Inbound type="solid" />,
    allow: allowAccess.inbound,
    subMenu: [
      {
        name: 'Inbound SO WRHS',
        id: 'inboundv2',
        link: `${inboundSoWarehouse}?type=${warehousePageLocationType.toString()}`,
        pageID: InboundSupplyOrderWarehouseRBAC.pageID,
      },
      {
        name: 'Inbound SO Hub',
        id: 'inboundvhub2',
        link: `${inboundSoHub}?type=${hubPageLocationType.toString()}`,
        pageID: InboundSupplyOrderHubRBAC.pageID,
      },
      {
        name: 'Generate Package ID',
        id: 'package_id_generator',
        link: SupplyOrderRouterDetail.PackageIdGeneratorRouter.path,
        pageID: SupplyOrderRouterDetail.PackageIdGeneratorRouter.rbacPageID,
      },
      {
        name: 'Generate Koli ID',
        id: 'koli_id_generator',
        link: koliIDGenerator,
        pageID: GenerateKoliPageRBAC.pageID,
        allow: [],
      },
      {
        name: 'Generate Asset ID',
        id: 'generate_asset_id',
        link: SupplyOrderRouterDetail.AssetIdGeneratorRouter.path,
        pageID: GenerateAssetRBAC.pageID,
        allow: [],
      },
      {
        name: 'SO Approval',
        id: 'supply_order_approval',
        link: supplyOrderApproval,
        pageID: supplyOrderApprovalPageRBAC.pageID,
        allow: [],
      },
      {
        name: 'Putaway Hub',
        id: 'putaway_hub',
        link: SupplyOrderRouterDetail.PutawayHubRouter.path,
        pageID: PutawayHubPageRBAC.pageID,
      },
    ],
  },
  {
    name: 'Outbound',
    id: 'Outbound',
    link: purchaseOrderLite,
    icon: <Outbound type="solid" />,
    allow: allowAccess.outbound_supply_order,
    subMenu: [
      {
        name: 'Supply Order',
        id: 'outbound_so',
        link: SupplyOrderRouterDetail.OutboundSORouter.path,
        pageID: SupplyOrderRouterDetail.OutboundSORouter.rbacPageID,
      },
      {
        name: 'Replenish Letdown (V2)',
        id: 'replenish_letdown',
        link: SupplyOrderRouterDetail.ReplenishmentLetdownRouter.path,
        pageID: SupplyOrderRouterDetail.ReplenishmentLetdownRouter.rbacPageID,
      },
      {
        name: 'Replenish Putaway (V2)',
        id: 'replenish_putaway',
        link: SupplyOrderRouterDetail.ReplenishmentPutawayRouter.path,
        pageID: SupplyOrderRouterDetail.ReplenishmentPutawayRouter.rbacPageID,
      },
      {
        name: 'Tugas Replenish (V1)',
        id: 'replenishmentTask',

        link: SupplyOrderRouterDetail.ReplenishmentTaskRouter.path,
        allow: SupplyOrderRouterDetail.ReplenishmentTaskRouter.allowedRoles,
        pageID: ReplenishmentTaskPageRBAC.pageID,
      },
      {
        name: 'Jadwal Replenish',
        id: 'replenishmentSchedule',

        link: SupplyOrderRouterDetail.ReplenishmentScheduleRouter.path,
        allow: SupplyOrderRouterDetail.ReplenishmentScheduleRouter.allowedRoles,
        pageID: ReplenishmentScheduleRBAC.pageID,
      },
      {
        name: 'Konfigurasi Replenishment',
        id: 'replenishmentConfiguration',
        link: SupplyOrderRouterDetail.ReplenishmentConfigRouter.path,
        allow: SupplyOrderRouterDetail.ReplenishmentConfigRouter.allowedRoles,
        pageID: ReplenishmentConfigPageRBAC.pageID,
      },
      {
        name: 'Koli Hilang di Staging',
        id: 'koli_lost',
        link: koliLost,
        allow: [],
        pageID: KoliLostPageRBAC.pageID,
      },
      {
        name: 'Xdock',
        id: 'xdock',
        link: SupplyOrderRouterDetail.XdockRouter.path,
        allow: SupplyOrderRouterDetail.XdockRouter.allowedRoles,
        pageID: XdockRBAC.pageID,
      },
      {
        name: 'Xdock V2',
        id: 'xdockv2',
        link: SupplyOrderRouterDetail.XdockV2Router.path,
        allow: SupplyOrderRouterDetail.XdockV2Router.allowedRoles,
        pageID: XdockV2RBAC.pageID,
      },
      {
        name: 'Konfigurasi SKU Outbound',
        id: 'outbound_sku_config',
        link: SupplyOrderRouterDetail.OutboundSKUConfigRouter.path,
        allow: SupplyOrderRouterDetail.OutboundSKUConfigRouter.allowedRoles,
        pageID: SupplyOrderRouterDetail.OutboundSKUConfigRouter.rbacPageID,
      },
      {
        name: 'Limit SKU per SO',
        id: 'limit_sku',
        link: SupplyOrderRouterDetail.LimitSKURouter.path,
        allow: SupplyOrderRouterDetail.LimitSKURouter.allowedRoles,
        pageID: limitSkuPageRBAC.pageID,
      },
      {
        name: 'Master Area Picking',
        id: 'master_area_picking',
        link: MasterAreaPickingListRouter.path,
        allow: [],
        pageID: MasterAreaPickingListRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Chat Moderation',
    id: 'chat_moderation',
    link: ChatChannelRouter.path,
    icon: <Message type="solid" />,
    subMenu: [
      {
        name: 'Chat Channels',
        id: 'chat_channels',
        link: ChatChannelRouter.path,
        pageID: ChatChannelRouter.rbacPageID,
      },
      {
        name: 'Banned Keywords',
        id: 'banned_keywords',
        link: BannedKeywordRouter.path,
        pageID: BannedKeywordRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Pesanan',
    id: 'order',
    link: ``,
    icon: <Pesanan type="solid" />,
    allow: allowAccess.order,
    subMenu: [
      {
        name: 'Pesanan Berlangsung',
        id: 'order',
        link: OnGoingRoutes.newOrder,

        allow: allowAccess.pesanan_berlangsung,
      },
      {
        name: 'Pesanan Berlangsung V2',
        id: 'order',
        link: OnGoingV2Routes.newOrder,

        pageID: OngoingOrdersRBAC.pageID,
      },
      {
        name: 'Pooling Map',
        id: 'order',
        link: poolingMap,
        pageID: PoolingMapRolesRBAC.pageID,
      },
      {
        name: 'Semua Pesanan V2',
        id: 'all_order_v2',
        link: OrderRouterDetail.AllOrderV2Router.path,
        pageID: OrderRouterDetail.AllOrderV2Router.rbacPageID,
      },
      {
        name: 'Buat Pesanan',
        id: 'create_order',
        link: createOrder,
        pageID: CreateOrderRolesRBAC.pageID,
      },
      {
        name: 'Driver Monitoring',
        id: 'dashboard_monitor',

        link: OrderRouterDetail.DriverMonitoringRouter.path,
        pageID: DriverMonitoringRolesRBAC.pageID,
      },
    ],
  },
  {
    name: 'Pengaturan Fulfillment',
    id: 'fulfillment_settings',
    link: '',
    icon: <Setting type="solid" />,
    pageID: AdditionalSLARolesRBAC.pageID,
    subMenu: [
      {
        name: 'Additional SLA',
        id: 'additional_SLA',

        link: OrderRouterDetail.AdditionalSLARouter.path,
        pageID: AdditionalSLARolesRBAC.pageID,
      },
      {
        name: 'ASLA Config',
        id: 'ASLA_log',

        link: OrderRouterDetail.ASLALogRouter.path,
        pageID: AdditionalSLALogRolesRBAC.pageID,
      },
    ],
  },
  {
    name: 'Promotional',
    id: 'promo',
    link: promotion,
    icon: <Promotional type="solid" />,
    allow: allowAccess.promotion,
    subMenu: [
      {
        name: 'Flash Sale',
        id: 'flash_sale',
        link: PromotionRouterDetail.FlashSaleRouter.path,
        pageID: flashSaleRBAC.pageID,
      },
      {
        name: 'Milestone',
        id: 'milestone',
        link: MilestoneListRouter.path,
        pageID: milestoneListRBAC.pageID,
        allow: MilestoneListRouter.allowedRoles,
      },
      {
        name: 'Promo',
        id: 'promo',
        link: promotion,
        pageID: promotionRBAC.pageID,
      },
      {
        name: 'Kombo Hemat',
        id: 'flexi_combo',
        link: PromotionRouterDetail.FlexiComboRouter.path,
        pageID: PromotionRouterDetail.FlexiComboRouter.rbacPageID,
      },
      {
        name: 'Referral Mission',
        id: 'referral_mission_list',
        link: referralMissionList,
        pageID: referralMissionListRBAC.pageID,
        allow: allowAccess.promotion_referral_setting,
      },
      {
        name: 'Referral Setting',
        id: 'referral_setting',
        link: referralSetting,
        pageID: referralSettignRBAC.pageID,
      },
      {
        name: 'Referral VIP',
        id: 'referral_vip',
        link: PromotionRouterDetail.ReferralVIPRouter.path,
        pageID: PromotionRouterDetail.ReferralVIPRouter.rbacPageID,
      },
      {
        name: 'GWP Setting',
        id: 'gift_with_purchase_setting',
        link: PromotionRouterDetail.GiftWithPurchaseRouter.path,
        pageID: PromotionRouterDetail.GiftWithPurchaseRouter.rbacPageID,
      },
      {
        name: 'Purchase with Purchase',
        id: 'purchase_with_purchase_setting',
        link: PromotionRouterDetail.PurchaseWithPurchaseRouter.path,
        pageID: PromotionRouterDetail.PurchaseWithPurchaseRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Unique Voucher',
    id: 'unique_voucher',
    link: uniqueVoucherList,
    icon: <Discount type="solid" />,
    subMenu: [
      {
        name: 'Voucher List',
        id: 'unique_voucher_list',
        link: uniqueVoucherList,
        pageID: uniqueVoucherVoucherListRolesRBAC.pageID,
      },
      {
        name: 'Campaign List',
        id: 'unique_voucher_campaign_list',
        link: uniqueVoucherCampaignList,
        pageID: uniqueVoucherCampaignListRolesRBAC.pageID,
      },
    ],
  },
  {
    name: 'Capacity Handler',
    id: 'capacity_handler',
    link: loadingDock,
    icon: <Capacity type="solid" />,
    subMenu: [
      {
        name: 'Master Loading Dock',
        id: 'loading_dock',
        link: LoadingDockRouter.path,
        pageID: MasterLoadingDockRBAC.pageID,
      },
      {
        name: 'Master Time Slot',
        id: 'master_time_slot',
        link: MasterTimeSlotRouter.path,
        pageID: MasterTimeSlotRBAC.pageID,
      },
      {
        name: 'Jadwal PO Sourcing',
        id: 'po_sourching_schedule',
        link: InboundScheduleRouter.path,
        pageID: InboundScheduleRBAC.pageID,
      },
    ],
  },
  {
    name: 'Fraud',
    id: 'fraud',
    link: fraudSetting,
    icon: <Fraud type="solid" />,
    allow: allowAccess.fraud,
    subMenu: [
      {
        name: 'Auto Cancel Rule List',
        id: 'Watchtower Rule List',
        link: WatchTowerAutoCancelRuleListRouter.path,
        pageID: WatchtowerAutoCancelRuleListRBAC.pageID,
      },
      {
        name: 'Watchtower Rule List',
        id: 'Watchtower Rule List',
        link: WatchTowerRuleRouter.path,
        pageID: WatchtowerRuleListRBAC.pageID,
      },
      {
        name: 'Query Rule List',
        id: 'Query Rule List',
        link: FraudRouterDetail.WatchTowerQueryRuleRouter.path,
        pageID: FraudRouterDetail.WatchTowerQueryRuleRouter.rbacPageID,
      },
      {
        name: 'Pengaturan Fraud',
        id: 'Pengaturan Fraud',
        link: fraudSetting,
        pageID: FraudSettingRBAC.pageID,
      },
      {
        name: 'Fraud Detection',
        id: 'fraud_detection',
        link: FraudRouterDetail.FraudDetectionRouter.path,
        pageID: FraudDetectionRBAC.pageID,
      },
      {
        name: 'Blacklist/Whitelist',
        id: 'fraud_black_and_white_list',
        link: BlacklistAndWhitelistRouter.path,

        pageID: FraudBlacklistAndWhitelistRBAC.pageID,
      },
      {
        name: 'Referral Fraud',
        id: 'fraud_referral',
        link: FraudRouterDetail.ReferralFraudRouter.path,
        pageID: FraudRouterDetail.ReferralFraudRouter.rbacPageID,
      },
      {
        name: 'Parameter List',
        id: 'fraud_parameter',
        link: fraudWatchTowerParameters,
        pageID: WatchtowerParameterRBAC.pageID,
      },
      {
        name: 'User Fraud Status',
        id: UserFraudStatusRouter.name,
        link: UserFraudStatusRouter.path,
        pageID: UserFraudStatusRBAC.pageID,
      },
      {
        name: 'Area Detection',
        id: WatchtowerAreaDetectionRouter.name,
        link: WatchtowerAreaDetectionRouter.path,
        pageID: WatchtowerAreaDetectionRBAC.pageID,
      },
    ],
  },
  {
    name: 'Loyalty',
    id: 'loyalty',
    link: coinEarned,
    icon: <Loyalty type="solid" />,
    allow: allowAccess.loyalty,
    subMenu: [
      {
        name: 'Riwayat Koin',
        id: 'Coin History',
        link: coinHistory,

        allow: allowAccess.loyalty_coin_history,
      },
      {
        name: 'Koin di Dapat',
        id: 'Koin_di_Dapat',
        link: coinEarned,

        allow: allowAccess.loyalty_coin_earned,
      },
      {
        name: 'Koin di Tukar',
        id: 'Koin di Tukar',
        link: coinExchange,

        allow: allowAccess.loyalty_coin_exchange,
      },
      {
        name: 'Aktivitas',
        id: 'Aktivitas',
        link: loyaltyActivity,

        allow: allowAccess.loyalty_activity,
      },
      {
        name: 'Voucher',
        id: 'Voucher',
        link: loyaltyVoucher,

        allow: allowAccess.loyalty_voucher,
      },
      {
        name: 'Campaign Loyalty',
        id: 'campaign_loyalty',
        link: campaignLoyalty,

        allow: allowAccess.loyalty_voucher,
      },
      {
        name: 'Widget',
        id: 'widget',
        link: LoyaltyRouterDetail.LoyaltyWidgetRouter.path,

        allow: LoyaltyRouterDetail.LoyaltyWidgetRouter.allowedRoles,
      },
    ],
  },
  {
    name: 'SO Automation',
    id: 'so_automation',
    icon: <AddNote type="solid" />,
    allow: allowAccess.so_automation,
    subMenu: [
      {
        name: 'SO Parameters',
        id: 'so_parameters',
        link: SOAutomationRouter.SOParametersRouter.path,
        pageID: SoParametersPageRBAC.pageID,
      },
      {
        name: 'SO Schedules',
        id: 'so_schedules',
        link: SOAutomationRouter.SOSchedulesRouter.path,
        pageID: SoSchedulesPageRBAC.pageID,
      },
      {
        name: 'SO Reports',
        id: 'so_reports',
        link: SOAutomationRouter.SOReportsRouter.path,
        pageID: SoReportPageRBAC.pageID,
      },
    ],
  },
  {
    name: 'HCU',
    id: 'hcu',
    link: hcu,
    icon: <Group type="solid" />,
    pageID: HCURolesRBAC.pageID,
  },
  {
    name: 'SKP',
    id: 'skp',
    icon: <Doc type="solid" />,
    allow: allowAccess.skp,
    subMenu: [
      {
        name: 'Sourcing',
        id: 'skp_sourcing',
        link: SKPRouterDetail.SourcingSKP.path,
        pageID: SKPRouterDetail.SourcingSKP.rbacPageID,
      },
      {
        name: 'Finance / Head Catman',
        id: 'skp_finance',
        link: FinanceRouter.path,
        pageID: FinanceRouter.rbacPageID,
      },
      {
        name: 'Campaign',
        id: 'skp_campaign',
        link: CampaignRouter.path,
        pageID: CampaignRouter.rbacPageID,
      },
      {
        name: 'Internal / Private Label',
        id: 'skp_internal',
        link: InternalSKPRouter.path,
        pageID: InternalSKPRouter.rbacPageID,
      },
      {
        name: 'Syarat Ketentuan',
        id: 'terms_and_condition_skp',
        link: SKPRouterDetail.TermsAndConditionSKP.path,
        pageID: SKPRouterDetail.TermsAndConditionSKP.rbacPageID,
      },
    ],
  },
  {
    name: 'Ticket Scanner',
    id: 'TicketScanner',
    link: TicketScannerRouter.path,
    icon: <Scan type="solid" />,
    allow: TicketScannerRouter.allowedRoles,
  },
  {
    name: 'A/B Testing',
    id: 'ABAdminList',
    link: ABAdminRouterDetail.ABAdminLoginRouter.path,
    icon: <Setting type="solid" />,
    pageID: ABAdminRouterDetail.ABAdminLoginRouter.rbacPageID,
    subMenu: [
      {
        name: 'Eksperimen List',
        id: 'ab_admin_experiment_list',
        link: ABAdminRouterDetail.ABAdminLoginRouter.path,
        pageID: ABAdminRouterDetail.ABAdminLoginRouter.rbacPageID,
      },
      {
        name: 'User List',
        id: 'ab_admin_user_list',
        link: ABAdminRouterDetail.ABAdminUserListRouter.path,
        pageID: ABAdminRouterDetail.ABAdminUserListRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'Rak',
    id: 'rak',
    link: rack,
    icon: <Rak type="solid" />,
    subMenu: [
      {
        name: 'Master Rak',
        id: 'master_rak',
        link: rack,
        allow: RackRouterDetail.RackListRouter.allowedRoles,
        pageID: RackRouterDetail.RackListRouter.rbacPageID,
      },
      {
        name: 'Master Area',
        id: 'master_area',
        link: RackRouterDetail.AreaListRouter.path,
        allow: RackRouterDetail.AreaListRouter.allowedRoles,
        pageID: RackRouterDetail.AreaListRouter.rbacPageID,
      },
    ],
  },
  {
    name: 'ASTROmation',
    id: 'ticketing',
    icon: <AddNote type="solid" />,
    subMenu: [
      {
        name: 'Buat Tiket',
        id: 'ticketing_create',
        link: ticketingCreate,
        pageID: CreateTicketRoute.rbacPageID,
      },
      {
        name: 'Tiket Saya',
        id: 'ticketing_my_tickets',
        link: ticketingMyTickets,
        pageID: MyTicketsRoute.rbacPageID,
      },
      {
        name: 'Semua Tiket',
        id: 'ticketing_all_tickets',
        link: ticketingAllTickets,
        pageID: AllTicketsRoute.rbacPageID,
      },
    ],
  },
]

export default config
